require('angular');
require('sogei-uikit');
require('app');

angular.bootstrap(document, ['registrazione-ente-angular'], {strictDi: true});



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/main.js
// module id = 41
// module chunks = 1